import React from 'react';
import {Redirect, Route, useLocation} from 'react-router-dom';
import {isEntitled} from '../store';
import PropTypes from 'prop-types';
import {logError, PageErrorTile} from './ErrorBounds';
import {ErrorBoundary} from 'react-error-boundary';

export const PrivateRoute = ({component: Component, ...rest}) => {
  const location = rest.location || useLocation();

  return <Route {...rest} render={props => localStorage.getItem('token')
    ? ((!rest.entitlements || isEntitled(rest.entitlements))
      && <ErrorBoundary
        FallbackComponent={PageErrorTile}
        onError={logError}><Component {...props} /></ErrorBoundary>
      || <Redirect to={{pathname: '/splash'}}/>)
    : <Redirect to={{pathname: '/login', search: location.search}}/>}/>;
};
// ETODO Prop Types
PrivateRoute.propTypes = {
  component: PropTypes.node,
};
